import { DefaultBarChartUiOptions } from './utils/echart';

export const DefaultScatterChartProps = {
  type: 'scatter',
  displayName: 'Scatter chart',
  uiOptions: DefaultBarChartUiOptions,
} as const;
